/* eslint-disable import/prefer-default-export */
import ReactModal from 'react-modal';
import styled, { css } from 'styled-components';

const FULL_SIZE = '100%';
const NOT_FULL_SIZE = '95%';
const UNSET = 'unset';

export const StyledReactModal = styled(ReactModal)`${
  (props) => {
    const size = props.fullPage ? FULL_SIZE : NOT_FULL_SIZE;

    return css`
      opacity: 0;
      transition: opacity 300ms ease-in-out;

      &.ReactModal__Overlay--after-open {
        opacity: 1;
        z-index: 1000;
      }

      &.ReactModal__Overlay--before-close {
        opacity: 0;
      }

      &.ReactModal__Content {
        position: absolute;
        inset: 40px;
        background-color: rgb(255, 255, 255);
        overflow: auto;
        border-radius: 4px;
        outline: none;
        min-width: ${size};
        min-height: ${size};
        left: 120% !important;
      }

      &.ReactModal__Content.ReactModal__Content--after-open {
        top: 50% !important;
        left: 50% !important;
        right: auto !important;
        bottom: auto !important;
        margin-right: -50% !important;
        transform: translate(-50%, -50%) !important;
        padding: 0 !important;
        border: none !important;
        box-shadow: 1px 7px 16px rgba(0, 0, 0, 0.2);
        opacity: 1;
      }
    `;
  }
}`;

export const StyledButton = styled.button`
  position: absolute;
  top: 0;
  right: 10px;
  font-size: 14px;
  color: #97b8dd;
  border: 0;
  background-color: transparent;
  padding: 0;
`;

export const StyledTitle = styled.h3`${(props) => {
  const cl = props.styled?.color || UNSET;
  const ff = props.styled?.fontFamily || UNSET;

  return css`
  && {
    color: ${cl};
    font-family: ${ff};
    font-size: 20px;
    margin: 20px 15px 0;
  }
  `;
}}`;

export const StyledWrapper = styled.div`
  height: calc(100% - 70px);
`;
